import HasRole from "modules/5_view_helpers/HasRole";
import { createCustomFormLinks, createMenuItems } from "../helpers";

const getAdministrationNav = (administration_custom_forms, administration_menus) => {
  const AdministrationRoles = HasRole({ resource_type: "Administration::AutomatedInvoice" });
  if (AdministrationRoles || _.isNotEmpty(administration_custom_forms) || _.isNotEmpty(administration_menus)) {
    let adminMenu = { icon: "fa fa-book", label: "Administration", content: [] };
    const AutomatedInvoiceRoles = HasRole({ resource_type: "Administration::AutomatedInvoice" });
    if (AutomatedInvoiceRoles) {
      adminMenu?.content?.push({ label: "Automated Invoices", to: "/administration/automated_invoices" });
    }
    adminMenu.content = _.concat(
      adminMenu?.content,
      createCustomFormLinks(administration_custom_forms),
      createMenuItems(administration_menus)
    );
    return adminMenu;
  }
};

export default getAdministrationNav;
